
import { SignupView } from "src/sections/signup";

export default function SignupPage() {
    return (
        <SignupView />
    );
}